import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import "./RDDDCloserRequest.css";
import { Link, useNavigate } from "react-router-dom";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";



const secondaryTabs = ["All", "Active", "Closed", "Pre-Closed", "Reject"];
const rowsPerPage = 10;

const RDReport = () => {
  const navigate = useNavigate();
   const dispatch = useDispatch();

  const [activeMainTab, setActiveMainTab] = useState("RD");
  const [activeSecondary, setActiveSecondary] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { profile } = useSelector((state) => state.userProfile);
  

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
   const [closerDate, setCloserDate] = useState("");
      const [closerRemark, setCloserRemark] = useState("");
        const [accountCloseDialog, setAccountCloseDialog] = useState({
          open: false,
          accountId: null,
        });


const handleViewEmi = (account) => {
  navigate(`/Deposit/EmiDetails/${account.id}`, { state: { account } });
};



  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);


  // Fetch Accounts
  const fetchAccounts = async () => {
    try {
      setLoading(true);
      const superAdminId = profile.superAdminId || 14;
      const branchId = localStorage.getItem("userId") || 56;

      const res = await axios.get("https://narrowitsolution.in/api/deposit/list", {
        params: {
          superAdminId,
          branchId,
          page: currentPage,
          limit: rowsPerPage,
          accountType: activeMainTab,
          status: activeSecondary !== "All" ? activeSecondary : undefined,
          search: searchQuery || undefined,
        },
      });

      console.log("deposit list:",res)
      if (res.data.success) {
        setAccounts(res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
      } else {
        setAccounts([]);
      }
    } catch (err) {
      console.error("Error fetching deposit accounts:", err);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, [activeMainTab, activeSecondary, searchQuery, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [activeMainTab, activeSecondary]);


    const openAccountCloseDialog = (accountId) => {
      setAccountCloseDialog({ open: true, accountId });
    };
  
    const closeAccountCloseDialog = () => {
      setAccountCloseDialog({ open: false, accountId: null });
      setCloserDate("");
      setCloserRemark("");
    };
  
    const handleRDDDAccountClose = async (e) => {
      e.preventDefault();
  
      if (!closerDate || !closerRemark) {
        toast.error("Date and remark required");
        return;
      }
  
      try {
        const res = await axios.put(
          // `https://narrowitsolution.in/api/saving-account/request-close/${accountCloseDialog.accountId}`,
          {
            closureRemark: closerRemark,
            closureDate: closerDate,
          }
        );
  
        console.log(res);
        toast.success("Account closed successfully");
        fetchAccounts();
        closeAccountCloseDialog();
      } catch (err) {
        toast.error(err?.response?.data?.message||"Failed to close saving account");
        // console.error(err);
      }
    };


  const renderTable = useMemo(() => {
  if (loading) {
    return (
      <tr>
        <td colSpan="6" style={{ textAlign: "center" }}>Loading...</td>
      </tr>
    );
  }

  if (!accounts.length) {
    return (
      <tr>
        <td colSpan="6" style={{ textAlign: "center" }}>No Data Found</td>
      </tr>
    );
  }

  return accounts.map((acc, index) => {
    const isPending = acc.status === "Pending";

    return (
      <tr key={acc.id}>
        {/* SN */}
        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>

        {/* Account No */}
        <td>{acc.accountNo}</td>

        {/* Customer Name */}
        <td>{acc.customerName || "--"}</td>

        {/* Account Type */}
        <td>{acc.accountType || "--"}</td>

        {/* Scheme */}
        <td>{acc.schemeName || "--"}</td>

        {/* Frequency */}
        {/* <td>{acc.installmentFrequency || "--"}</td> */}

        {/* ROI */}
        {/* <td>{acc.roi || "--"}%</td> */}

        {/* Installment Amount */}
        {/* <td>₹{acc.amount?.toLocaleString() || 0}</td> */}

        {/* Tenure */}
        {/* <td>{acc.tenure || "--"}</td> */}

        {/* Principal Amount */}
        {/* <td>₹{acc.principalAmount?.toLocaleString() || "--"}</td> */}

        {/* Passbook */}
        {/* <td>
          <Link to={"/Banking/Report/RDDDPassbook"} state={{row:acc}} className="rd-cirtificate-open-btn">Open</Link>
        </td> */}

        {/* RD Certificate */}
        {/* <td>
          {isPending ? (
           <span className="status-badge-not-approved">Not Approved</span>
          ) : (
            <Link
              to={"/Banking/Report/RDCertificates"}
              className="rd-cirtificate-open-btn"
              state={{ row: acc }}
            >
              Open
            </Link>
          )}
        </td> */}
        {/* Refer ID */}
        {/* <td>{acc.referralId || "--"}</td> */}

        {/* Nominee ID */}
        {/* <td>{acc.nomineeCusId || "--"}</td> */}

        {/* RD Cirtificate */}
        {/* <td><Link to={"/Banking/Report/RDCertificates"} className="rd-cirtificate-open-btn" state={{ row: acc }}>Open</Link></td> */}
        {/* <td><Link to={"/Banking/Report/Membership"} className="rd-cirtificate-open-btn" state={{ row: acc }}>Open</Link></td> */}

        {/* Action */}
        {/* <td>
          {isPending ? (
            <span className="status-badge-not-approved">Not Approved</span>

          ) : (
            <button
              className="DDFDReportview-btn"
              onClick={() => handleViewEmi(acc)}
            >
              View
            </button>
          )}
        </td> */}

         <td>
                   {acc.status==="CloseRequested"?(
                     <button
                      className="rddd-account-close-req-action-btn"
                       disabled
                            title="Account close Requested"
                            aria-disabled="true"
                    >
                      Requested
                    </button>
                   ):acc.status==="closed"?(
                    <button
                      className="rddd-account-close-req-action-btn"
                       disabled
                            title="Account already closed"
                            aria-disabled="true"
                    >
                      Closed
                    </button>
                   ):(
                     <button
                      className="rddd-account-close-req-action-btn"
                      onClick={() => openAccountCloseDialog(acc.id)}
                    >
                      Close
                    </button>
                   )}
                  </td>
      </tr>
    );
  });
}, [accounts, loading, currentPage]);

  return (
    <div className="rddd-account-close-req-container">
      <h2 style={{ textAlign: "center", marginBottom: 10 }}>
        {activeMainTab} Account Close Request
      </h2>

      {/* Main Tabs */}
      <div className="rddd-account-close-req-changing-main-tabs">
        {["RD", "DD"].map((tab) => (
          <button
            key={tab}
            className={`rddd-account-close-req-changing-main-btn ${
              activeMainTab === tab ? "active" : ""
            }`}
            onClick={() => setActiveMainTab(tab)}
          >
            {tab} Report
          </button>
        ))}
      </div>

      {/* Secondary Tabs */}
      <div className="rddd-account-close-req-changing-secondary-tabs">
        {secondaryTabs.map((tab) => (
          <button
            key={tab}
            className={`rddd-account-close-req-changing-secondary-btn ${
              activeSecondary === tab ? "active" : ""
            }`}
            onClick={() => setActiveSecondary(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Search */}
      <div className="rddd-account-close-req-searchbox">
        <input
          type="text"
          placeholder="Search by Account No / Customer..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* Table */}
      <div className="rddd-account-close-req-table-container">
        <table className="rddd-account-close-req-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer Name</th>
              <th>Account Type</th>
              <th>scheme Name</th>
              {/* <th>installment Frequency</th>
              <th>ROI</th>
              <th>Installment Amount</th>
              <th>Tenure</th>
              <th>Principal Amount</th>
              <th>Passbook</th>
              <th>Cirtificate</th> */}
              {/* <th>MemberShip Form</th> */}
              {/* <th>Refer ID</th>
              <th>Nominee ID</th> */}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>{renderTable}</tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="rddd-account-close-req-pagination-section">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Previous
        </button>

        <span>
          Page {currentPage} of {totalPages}
        </span>

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </button>
      </div>


       {/* Loan Close Confirmation Dialog */}
      {accountCloseDialog.open && (
        <div className="account-closer-dialog-overlay">
          <div className="account-closer-dialog">
            <h3>{activeMainTab} Account Close Confirmation</h3>

            <form onSubmit={handleRDDDAccountClose}>
              <input
                type="date"
                value={closerDate}
                onChange={(e) => setCloserDate(e.target.value)}
              />
              <input
                type="text"
                placeholder="Remark"
                value={closerRemark}
                onChange={(e) => setCloserRemark(e.target.value)}
              />

              <div className="account-closer-dialog-buttons">
                <button type="submit" className="btn-confirm">
                  Close
                </button>
                <button
                  type="button"
                  onClick={closeAccountCloseDialog}
                  className="btn-cancel"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default RDReport;
